import { parsePhoneNumberFromString } from "libphonenumber-js";

export function validatePhoneForCountry(phoneNumber, countryCode) {
    if (!phoneNumber) return true;
    if (!countryCode) return false;
    countryCode = countryCode.toUpperCase();
    phoneNumber = phoneNumber.replace(/\s/g, "");
    try {
        const parsedPhone = parsePhoneNumberFromString(phoneNumber, countryCode);
        if (!parsedPhone || parsedPhone.country != countryCode) return false;
        return parsedPhone.isValid();
    } catch {
        return false;
    }
}
export function validatePhone(phoneNumber) {
    phoneNumber = phoneNumber.replace(/\s/g, "");
    const regex = RegExp('^([+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[0-9]*)?$');     //example +2001456789 only without spaces or - 
    return regex.test(phoneNumber || '');
}